import { Button, Tooltip } from '@mui/material';
type Props = {
  link: string;
  label: string;
  icon: any;
};
export default function TableButton(props: Props): React.ReactElement {
  return (
    <Tooltip title={props.label}>
      <Button sx={{ marginRight: 1 }} variant="text" href={props.link}>
        {props.icon}
      </Button>
    </Tooltip>
  );
}
